import _ from 'lodash';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-icon-trash',
  templateUrl: './icon-trash.component.html',
  styleUrls: ['./icon-trash.component.scss']
})
export class IconTrashComponent implements OnInit {

  @Input() invalid = false;

  public classes: string[] = ['icon--regular'];

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    const invalid = _.get(changes, 'invalid.currentValue', this.invalid);
    this.classes = invalid ? ['icon--error']: ['icon--regular'];
  }

  ngOnInit(): void {
  }
}
